import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ConstantService } from '../../components/common/utils/constant.service';
import { Siniestros, SiniestralidadSiniestros } from '../../components/common/siniestros_entity';
import { Cliente } from '../login/cliente_login';
import { DatosSiniestro, MensajeSiniestro, MensajeCampoValor, Amparo, vTipoReclamoAsistencia, vDiagnosticosAsistencia, MensajeDocumentoServicio, vBeneficiarioAsistenciaMedica } from './siniestros_entity';
import { AsistenciaMedicaEntity } from '../masivos/datosGenerales/entities/asistencia_medica_entity';


@Injectable()
export class SiniestrosService {
    private url = "utils";

    constructor(public authHttp: AuthHttp) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    ConsultarSiniestros(cliente: Cliente): Observable<Siniestros> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/GetSiniestros", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    ConsultarSiniestralidadSiniestros(cliente: Cliente): Observable<SiniestralidadSiniestros[]> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/GetSiniestralidadSiniestros", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    ConsultaTrackingVehiculos(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/getTrackingVehiculo/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultaTrackingOtrosRamos(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/getTrackingOtrosRamos/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultaTrackingAsistencia(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/getTrackingAsistencia/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    ReportarSiniestroVehiculos(siniestro: DatosSiniestro): Observable<MensajeSiniestro> {
        let body = JSON.stringify(siniestro);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/reportarSiniestrosVehiculos", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    ReportarSiniestroOtrosRamos(siniestro: DatosSiniestro): Observable<MensajeSiniestro> {
        let body = JSON.stringify(siniestro);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/reportarSiniestroOtrosRamos", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    DetalleDeducible(codigo: number): Observable<object>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/Deducible/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }
    DetalleRcs(codigo: number): Observable<MensajeCampoValor[]>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/RC/"+ codigo, options).map(this.extractData)
            .catch(this.handleError);
    }

    ConsultaListadoAmparos(): Observable<Amparo[]>{
      let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
      let options = new RequestOptions({ headers: headers });
      return this.authHttp.get(this.url + "/getAmparos/", options).map(this.extractData)
          .catch(this.handleError);
  }

  ConsultaListaTipoReclamos(): Observable<vTipoReclamoAsistencia[]>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getTipoReclamos/", options).map(this.extractData)
        .catch(this.handleError);
  }
  ConsultaListaDiagnosticos(): Observable<vDiagnosticosAsistencia[]>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getDiagnosticos/", options).map(this.extractData)
        .catch(this.handleError);
  }

  ConsultarDocumentosByAmparo(idAmparo: number,tipReclamo:string): Observable<MensajeDocumentoServicio[]>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getDocumentos/"+ idAmparo+"/"+tipReclamo, options).map(this.extractData)
        .catch(this.handleError);
  }

  ConsultarPacientes(poliza:AsistenciaMedicaEntity): Observable<vBeneficiarioAsistenciaMedica[]>{
    let body = JSON.stringify(poliza);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/ConsultarBeneficiarios/",body,  options).map(this.extractData)
        .catch(this.handleError);
    }



    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/siniestros.service.ts